import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface ChatKeysState {
  [key: string]: string[] | undefined;
}

const initialState: ChatKeysState = {};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-chat-keys' })
export class ChatKeysStore extends Store<ChatKeysState> {
  constructor() {
    super(initialState);
  }
}
